import React from 'react'
import TextField from '@material-ui/core/TextField'

// @src imports
import { useEffect, useLoading, useState } from 'src/hooks'
import { AccountFragment, Storefront } from 'src/graphql'
import { Button, Fade, ProfileAvatar } from 'src/chrome'

import styles from './personalSiteOptions.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'

type PersonalSiteOptionsProps = {
  storefront: Storefront
  account: AccountFragment
  onSave: (storefront: Storefront) => Promise<void>
  onSaveMugshot: (imageSource: File) => void
}

const PersonalSiteOptions: React.FC<PersonalSiteOptionsProps> = props => {
  const {
    storefront,
    account: { firstName, lastName },
    onSave,
    onSaveMugshot,
  } = props

  const [data, setData] = useState(storefront)
  const loading = useLoading()

  const isDirty = data !== storefront

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      [e.currentTarget.name]: e.currentTarget.value,
    })
  }

  const reset = () => setData(storefront)

  const save = async () => {
    loading.start()
    try {
      await onSave(data)
    } finally {
      loading.end()
    }
  }

  useEffect(() => {
    setData(storefront)
  }, [storefront])

  return (
    <div>
      <div className={styles.sitePreferencesContainer}>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <ProfileAvatar
            size={100}
            style={{
              fontSize: '3.7rem',
              color: '#fff',
              letterSpacing: 1,
            }}
            account={{
              firstName,
              lastName,
              profileImageUrl: storefront.mugshot?.url,
            }}
            isEditable={true}
            onSave={onSaveMugshot}
          />
          <Text type="body">Sharing Picture</Text>
          <Text type="caption">
            For best results, image dimensions should be 300x300 pixels.
          </Text>
        </div>
        <div style={{ width: '100%' }}>
          <TextField
            name={'slug'}
            value={data.slug}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth={true}
            label={'Your personalized URL'}
            style={{ marginRight: 15 }}
            onChange={onChange}
          />
          <TextField
            name={'biography'}
            value={data.biography}
            InputLabelProps={{
              shrink: true,
            }}
            multiline={true}
            fullWidth={true}
            // rowsMax={4}
            label={'Biography'}
            onChange={onChange}
          />
        </div>
      </div>
      <Fade fadeIn={4} fadeOut={4} isVisible={isDirty}>
        <div style={{ display: 'flex', marginTop: 25 }}>
          <Button
            title={'Reset'}
            disabled={loading.isLoading}
            onClick={reset}
            style={{ marginRight: 50 }}
          />
          <Button
            title={loading.isLoading ? 'Saving...' : 'Save'}
            disabled={loading.isLoading}
            buttonColor={'pink'}
            onClick={save}
          />
        </div>
      </Fade>
    </div>
  )
}

export default PersonalSiteOptions
